import { render } from "./StatisticsStaffNext.vue?vue&type=template&id=3a1e57f9&ts=true&lang=pug"
import script from "./StatisticsStaffNext.vue?vue&type=script&lang=ts"
export * from "./StatisticsStaffNext.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__